export const initialProjectDevicesState = {
    devicesById: {},
    deviceIdsByProjectId: {},
};
